<template>
  <bpb-scroller
    v-if="scrollerComponent === SCROLLER_SHOP_COMPONENT.default"
    :id="id"
    flickity-config-preset="teaser-default"
  >
    <slot />
  </bpb-scroller>
  <bpb-scroller-gallery
    v-else-if="scrollerComponent === SCROLLER_SHOP_COMPONENT.gallery"
    :id="id"
    class="scroller-gallery--lg-50-50"
    for-shop-teaser
  >
    <slot />
  </bpb-scroller-gallery>
</template>

<script>
export const SCROLLER_SHOP_COMPONENT = {
  gallery: 'bpb-scroller-gallery',
  default: 'bpb-scroller',
};
Object.freeze(SCROLLER_SHOP_COMPONENT);

export default {
  provide() {
    const scrollerShopContext = {};

    Object.defineProperty(scrollerShopContext, 'scrollerComponent', {
      enumerable: true,
      get: () => this.scrollerComponent,
    });

    return {
      scrollerShopContext,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    lgWithoutGallery: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      SCROLLER_SHOP_COMPONENT,
    };
  },
  computed: {
    isAboveLgBreakpoint() {
      return this.$store.getters['window/breakpointUp']('lg');
    },
    scrollerComponent() {
      if (!this.lgWithoutGallery) return SCROLLER_SHOP_COMPONENT.gallery;

      return this.isAboveLgBreakpoint
        ? SCROLLER_SHOP_COMPONENT.default
        : SCROLLER_SHOP_COMPONENT.gallery;
    },
  },
};
</script>
